import { AlertTriangle, XCircle } from 'lucide-react';

// "Double check" popup: lists anything out of place before the FTC report PDF is made.
export default function FtcPreflightDialog({ preflight, onClose, onEditClientInfo }) {
  if (!preflight) return null;
  const errors = preflight.issues.filter((i) => i.level === 'error');
  const warns = preflight.issues.filter((i) => i.level !== 'error');
  const clientIssue = preflight.issues.some((i) => ['Name', 'Address', 'City', 'State', 'ZIP', 'Phone', 'SSN', 'Email', 'Date of birth'].includes(i.field));
  const Row = ({ i, n }) => (
    <li className="flex gap-2 text-sm" data-testid={`ftc-preflight-issue-${n}`}>
      {i.level === 'error' ? <XCircle className="w-4 h-4 text-red-400 shrink-0 mt-0.5" /> : <AlertTriangle className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />}
      <span className={i.level === 'error' ? 'text-red-100' : 'text-amber-100'}><b>{i.field}:</b> {i.msg}</span>
    </li>
  );
  return (
    <div className="fixed inset-0 z-[130] bg-black/80 flex items-center justify-center p-4" data-testid="ftc-preflight-dialog">
      <div className="w-full max-w-lg max-h-[85vh] overflow-y-auto rounded-xl border border-red-500/50 bg-zinc-900 p-5 shadow-2xl">
        <h3 className="text-lg font-bold text-white flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-red-400" />Double-check before generating</h3>
        <p className="text-xs text-zinc-400 mt-1 mb-3">
          {errors.length ? `${errors.length} thing${errors.length > 1 ? 's look' : ' looks'} wrong` : 'Nothing is definitely wrong'}
          {warns.length ? ` · ${warns.length} to double-check` : ''}. The report has not been made yet.
        </p>
        <ul className="space-y-2">
          {[...errors, ...warns].map((i, n) => <Row key={`${i.field}-${n}`} i={i} n={n} />)}
        </ul>
        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          {clientIssue && onEditClientInfo && (
            <button type="button" onClick={() => { onClose(false); onEditClientInfo(); }} data-testid="ftc-preflight-edit-client"
              className="flex-1 rounded-lg bg-blue-600 hover:bg-blue-500 px-3 py-2 text-sm font-bold text-white">Fix client info</button>
          )}
          <button type="button" onClick={() => onClose(false)} data-testid="ftc-preflight-fix"
            className="flex-1 rounded-lg bg-zinc-700 hover:bg-zinc-600 px-3 py-2 text-sm font-bold text-white">Go back and fix</button>
          <button type="button" onClick={() => onClose(true)} data-testid="ftc-preflight-generate-anyway"
            className="flex-1 rounded-lg border border-red-500/60 px-3 py-2 text-sm font-semibold text-red-300 hover:bg-red-500/10">Generate anyway</button>
        </div>
      </div>
    </div>
  );
}
